import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

// Map i18n locale codes to the HTML lang attribute value.
// Simplified Chinese uses the `zh` locale code internally but should render
// `lang="zh-CN"` in the DOM so browsers apply CJK typography correctly.
const htmlLangMap: Record<string, string> = {
  en: 'en',
  zh: 'zh-CN',
  ko: 'ko',
  es: 'es',
  ja: 'ja',
  ar: 'ar',
  pt: 'pt',
  ru: 'ru',
  fr: 'fr',
  de: 'de',
  hi: 'hi',
  vi: 'vi',
  tr: 'tr',
  th: 'th',
};

export function resolveHtmlLang(lng: string | undefined): string {
  return htmlLangMap[lng ?? ''] ?? lng ?? 'en';
}

export default i18n;